/**
 * Gallery Event Related Enumerations
 * Used throughout the Exhibition/Competition flow for Event-Only Artists
 */

/**
 * GalleryEventType - Type of gallery event
 * 1 = Exhibition - A traditional gallery exhibition
 * 2 = Competition - An art competition with judging
 */
export enum GalleryEventTypeEnum {
  Exhibition = 1,
  Competition = 2
}

/**
 * GalleryEventStatus - Publication status of gallery events
 * 0 = All - Used for filtering to show all events
 * 1 = Draft - Event is in draft mode, not visible to artists
 * 2 = Published - Event is published and visible to artists
 */
export enum GalleryEventStatusEnum {
  All = 0,
  Draft = 1,
  Published = 2
}

/**
 * GalleryStaffRole - Roles for gallery staff assigned to events
 * 1 = Judge - Staff member who judges artworks in competitions
 * 2 = Curator - Staff member with curatorial responsibilities
 * 3 = Other - Custom role (user can specify)
 */
export enum GalleryStaffRoleEnum {
  Judge = 1,
  Curator = 2,
  Other = 3
}

/**
 * GalleryEventParticipantStatus - Tracks where artist is in the overall registration/submission flow
 * 1 = Registered - Participant has registered but not accepted terms
 * 2 = TermsAccepted - Participant has accepted terms and conditions
 * 3 = ArtworkSubmission - Participant is in artwork submission phase
 */
export enum GalleryEventParticipantStatusEnum {
  Registered = 1,
  TermsAccepted = 2,
  ArtworkSubmission = 3
}

/**
 * SubmissionStatus - Status of individual submission
 * 1 = Draft - Submission is in draft, can be edited
 * 2 = PendingPayment - Submission finalized, awaiting payment
 * 3 = PaymentCompleted - Payment has been completed successfully
 * 4 = PaymentFailed - Payment attempt failed
 */
export enum SubmissionStatusEnum {
  Draft = 1,
  PendingPayment = 2,
  PaymentCompleted = 3,
  PaymentFailed = 4
}
